import { createFileRoute } from '@tanstack/react-router';
import AllianceDuel from '../../components/AllianceDuel';

export const Route = createFileRoute('/events/alliance-duel')({
  component: () => <AllianceDuel />,
});







